var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynchronization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M13.964 22.565l-3.196-3.196a6.037 6.037 0 010-8.538 6.037 6.037 0 018.538 0l4.053 4.053M28.872 20.397l3.396 3.396a6.037 6.037 0 010 8.538 6.037 6.037 0 01-8.538 0l-4.011-4.011"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.709 16.024l4.918.101.101-4.917M23.18 26.863l-4.918-.101-.101 4.918"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynchronization);
export default __webpack_public_path__ + "static/media/synchronization.e862fbe2dc4bab60999310e874401a82.svg";
export { ForwardRef as ReactComponent };